import { offerStatus } from "./offer-workflow";
const DAY_MS = 24 * 60 * 60 * 1000;

function dateValue(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(`${value}T00:00:00Z`);
  return Number.isNaN(date.getTime()) ? null : Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
}

export function offerDaysOverdue(offer, today = new Date()) {
  if (!["offen", "versendet"].includes(offerStatus(offer))) return 0;
  const expected = dateValue(offer.datumErwarteterEntscheid);
  const current = dateValue(today);
  return expected === null || current === null ? 0 : Math.round((current - expected) / DAY_MS);
}

export function offerFollowUpState(offer, followUps = [], today = new Date()) {
  if (!["offen", "versendet"].includes(offerStatus(offer))) return { due: false, daysOverdue: 0, reason: null };

  const daysOverdue = offerDaysOverdue(offer, today);
  if (daysOverdue > 0) return { due: true, daysOverdue, reason: "overdue" };

  const latestFollowUp = followUps
    .filter(item => item.offerteId === offer.id)
    .map(item => dateValue(item.datum))
    .filter(value => value !== null)
    .sort((a, b) => b - a)[0];
  const baseline = latestFollowUp ?? dateValue(offer.datumVersand);
  const current = dateValue(today);
  const daysSinceContact = baseline === null || current === null ? 0 : Math.round((current - baseline) / DAY_MS);
  return { due: daysSinceContact >= 14, daysOverdue, reason: daysSinceContact >= 14 ? "stale" : null };
}
